/**
 * @Description: 打印机的信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  PrinterModel,
  PrinterSearchModel,
  PrinterPageSearchModel,
  PrinterAddModel,
  PrinterUpdateModel,
  IdsModel
} from '@/model/product/PrinterModel'

const baseUrl = Route.product + '/printer'

/**
 * 搜索分页数据
 */
export const pageSearchPrinter = (param: PrinterPageSearchModel) => {
  return https().request<RootObject<PageRespModel<PrinterModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchPrinter = (param: PrinterSearchModel) => {
  return https().request<RootObject<PrinterModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getPrinter = (id: number) => {
  return https().request<RootObject<PrinterModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addPrinter = (param: PrinterAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updatePrinter = (param: PrinterUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removePrinter = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemovePrinter = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
